module.exports = __webpack_public_path__ + "img/play.d212ae8d.svg";